/**
 * Enova Stores Section - Swiper init
 * Desktop: grid via Swiper (4 cols), Tablet: 2 cols, Mobile: 1.15 cols carousel
 */
(function() {
  var sections = document.querySelectorAll('.enova-stores');

  sections.forEach(function(section) {
    var swiperEl = section.querySelector('.enova-stores__swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    new Swiper(swiperEl, {
      slidesPerView: 1.15,
      spaceBetween: 16,
      watchOverflow: true,
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        990: {
          slidesPerView: 4,
          spaceBetween: 20
        }
      }
    });
  });
})();
